"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";
import { CSSProperties } from "react";
import { ErrorBoundary } from "react-error-boundary";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <ErrorBoundary
      fallback={null} // Jeśli wystąpi błąd, renderuje nic (pustkę)
      onError={(error) =>
        console.warn("Wyciszono błąd Toastera:", error.message)
      }
    >
      <Sonner
        theme={theme as ToasterProps["theme"]}
        className="toaster group"
        richColors
        style={
          {
            "--normal-bg": "var(--popover)",
            "--normal-text": "var(--popover-foreground)",
            "--normal-border": "var(--border)",
          } as CSSProperties
        }
        {...props}
      />
    </ErrorBoundary>
  );
};

export { Toaster };
